import {
  PROGRESSORGPLAN_FETCHING,
  PROGRESSORGPLAN_FAILED,
  PROGRESSORGPLAN_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PROGRESSORGPLAN_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PROGRESSORGPLAN_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PROGRESSORGPLAN_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
